import { BackgroundSection } from "@components/Sections";
import { Paragraph } from "@ui/Content";
import { H3 } from "@ui/Headings";
import { MainLogo } from "@ui/Logos/MainLogo";
import RefreshIcon from "@assets/icons/refresh-icon.svg";
import { ItemType } from "@enums/common.enum";

interface Props {
  itemType: ItemType;
}

export default function OpenGoogleItemScreen({ itemType = ItemType.EMAIL }: Props) {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center pt-[100px]">
        <MainLogo className="pb-[50px]" />

        <BackgroundSection
          className={"bg-white"}
          icon={<RefreshIcon className="stroke-green-800 stroke-[1.76]" />}
        />

        <H3 className="pt-5 text-gray-600 dark:text-invertedPrimary80">
          {`Open ${itemType == ItemType.EMAIL ? "an email" : "a meeting"} to use Meridian`}
        </H3>

        <div className="flex flex-col gap-4 pt-[32px] pb-6 px-8">
          <Paragraph>
            {`Please open any ${itemType == ItemType.EMAIL ? "message in Gmail" : "meeting in Google Calendar"} to access all features.`}
          </Paragraph>
        </div>
      </div>
    </div>
  );
}
